import {
  AsYouType,
  getCountries,
  getCountryCallingCode,
  type CountryCode,
} from "libphonenumber-js";

export type MoonPhoneCountry = {
  iso: CountryCode;
  flag: string;
  name: string;
  dialCode: string;
};

export function flagFromIso(iso: string): string {
  const upper = iso.toUpperCase();
  if (upper.length !== 2) return "";
  const codePoints = [...upper].map((c) => 127397 + c.charCodeAt(0));
  return String.fromCodePoint(...codePoints);
}

let regionNames: Intl.DisplayNames | null = null;
export function nameFromIso(iso: string): string {
  if (!regionNames) {
    try {
      regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    } catch {
      regionNames = null;
    }
  }
  return regionNames?.of(iso) ?? iso;
}

export const MOON_PHONE_COUNTRIES: MoonPhoneCountry[] = getCountries()
  .map((iso) => ({
    iso,
    flag: flagFromIso(iso),
    name: nameFromIso(iso),
    dialCode: `+${getCountryCallingCode(iso)}`,
  }))
  .sort((a, b) => a.name.localeCompare(b.name));

export function findMoonPhoneCountry(
  iso: string | null | undefined,
): MoonPhoneCountry | undefined {
  const normalized = iso?.trim().toUpperCase();
  if (!normalized) return undefined;
  return MOON_PHONE_COUNTRIES.find((country) => country.iso === normalized);
}

export function formatMoonPhoneNumber(
  nationalNumber: string,
  country: MoonPhoneCountry,
): string {
  return new AsYouType(country.iso).input(nationalNumber.replace(/\D/g, ""));
}
